import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NopagefoundComponent } from './nopagefound/nopagefound.component';
import { RouterModule } from '@angular/router';
import { CargaMasivaComponent } from './carga-masiva/carga-masiva.component';
import { PipesModule } from '../pipes/pipes.module';
import { NgDropFilesDirective } from '../directives/ng-drop-files.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserNotificationsComponent } from './user-notifications/user-notifications.component';
import { UploadComponent } from './upload/upload.component';
import { FooterComponent } from './footer/footer.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StepperComponent } from './stepper/stepper.component';
import { NgxPopper } from 'angular-popper';
import { DireccionComponent } from './direccion/direccion.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { NgSelectModule } from '@ng-select/ng-select';
import { SimpleModalModule } from 'ngx-simple-modal';
import { ChangePasswordComponent } from './changepassword/changepassword.component';
@NgModule({
  declarations: [
    HeaderComponent,
    NavbarComponent,
    NopagefoundComponent,
    CargaMasivaComponent,
    UserNotificationsComponent,
    UploadComponent,
    NgDropFilesDirective,
    FooterComponent,
    StepperComponent,
    DireccionComponent,
    ChangePasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    RouterModule,
    IMaskModule,
    PipesModule,
    NgbModule,
    FontAwesomeModule,
    NgxPopper,
    SimpleModalModule.forRoot({container: "modal-container"})
  ],
  exports: [
    NopagefoundComponent,
    HeaderComponent,
    CargaMasivaComponent,
    UploadComponent,
    UserNotificationsComponent,
    FooterComponent,
    NavbarComponent,
    StepperComponent,
    DireccionComponent
  ]
})
export class SharedModule { }
